module.exports = __webpack_public_path__ + "img/chavin_2.282cf7ec.png";